import { Box, Typography, useTheme } from '@mui/material'
import { Stack } from '@mui/system'
import { useNavigate } from 'react-router-dom'
import { ArrowForwardIos } from '@mui/icons-material'
import { isDebug } from '../utils/misc'
import { Appliance } from '../classes/appliances/Appliance'
import { useApp } from '../hooks/useApp'
import { APPLIANCES_WITHOUT_INSTALLER_LEVEL } from '../types/constants'

export interface AppliancePanelProps {
  appliance: Appliance
  url?: string
}

/**
 * Summarize device status.
 */
export function AppliancePanel(props: AppliancePanelProps): React.ReactElement {

  const app = useApp()
  const { appliance, url } = props
  const theme = useTheme()
  const navigate = useNavigate()

  const Icon = appliance.Icon
  // Should not have more than one, but show it if it has.
  const hwIds = [...new Set(appliance.controls.map(c => `${c.device.hw_id}${isDebug('port-numbers') ? ` #${c.device.id}` : ''}`))]

  const conditionalConfigArrow = () => {
    if (app.installerLevel) {
      return <ArrowForwardIos data-cy="icon-View" sx={{ cursor: 'pointer' }} onClick={() => url && navigate(url)}/>
    } else {
      if (APPLIANCES_WITHOUT_INSTALLER_LEVEL.includes(appliance.type)) {
        return <ArrowForwardIos data-cy="icon-View" sx={{ cursor: 'pointer' }} onClick={() => url && navigate(url)}/>
      } else {
        return <></>
      }
    }
  }

  return (
    <Box data-cy={`box-${appliance.getName()}`} sx={{
      backgroundColor: theme.palette.panelBackground.main,
      boxShadow: theme.boxShadow.main,
      borderRadius: '1.25rem',
      mb: 2,
    }}>
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: '4rem auto 2rem',
        alignItems: 'center',
        paddingLeft: '1rem',
        height: '5rem',
      }}>
        <Icon sx={{ color: theme.palette.iconColor.main }}/>
        <Stack>
          <Typography sx={{ color: theme.palette.panelText.main }}>
            {appliance.getName()}
            {appliance.controls.length > 0 && isDebug('port-numbers') ? ` [${appliance.controls.map(c => `#${c.port.id} ${c.port.port_number}`).join(' ')}]` : ''}
          </Typography>
          <Typography sx={{ color: theme.palette.grey[600] }}>{hwIds.join(' ')}&nbsp;</Typography>
        </Stack>
        {conditionalConfigArrow()}
      </Box>
    </Box>
  )
}
